import { lazy } from 'react';

const ConfigurationQrCodes = lazy(() => import('../../../containers/ConfigurationQrCodes/ConfigurationQrCodes'));
const Users = lazy(() => import('../../../containers/Users/Users'));
const Layouts = lazy(() => import('../../../containers/Layouts/Layouts'));
const EmailLayouts = lazy(() => import('../../../containers/EmailLayouts/EmailLayouts'));
const FormLayouts = lazy(() => import('../../../containers/FormLayouts/FormLayouts'));
const Screenings = lazy(() => import('../../../containers/Screenings/Screenings'));
const Tickets = lazy(() => import('../../../containers/Tickets/Tickets'));
const ProgrammationGroups = lazy(() => import('../../../containers/ProgrammationGroups/ProgrammationGroups'));
const Places = lazy(() => import('../../../containers/Places/Places'));
const Pricinglists = lazy(() => import('../../../containers/Pricinglists/Pricinglists'));
const Bucketlists = lazy(() => import('../../../containers/Bucketlists/Bucketlists'));
const Tickettypes = lazy(() => import('../../../containers/Tickettypes/Tickettypes'));
const TktInstances = lazy(() => import('../../../containers/TktInstances/TktInstances'));
const Tasks = lazy(() => import('../../../containers/Tasks/Tasks'));
const Distributors = lazy(() => import('../../../containers/Distributors/Distributors'));
const Activities = lazy(() => import('../../../containers/Activities/Activities'));
const Events = lazy(() => import('../../../containers/Events/Events'));
const Articles = lazy(() => import('../../../containers/Articles/Articles'));
const Articlecategories = lazy(() => import('../../../containers/Articlecategories/Articlecategories'));
const Postcategories = lazy(() => import('../../../containers/Postcategories/Postcategories'));
const Channels = lazy(() => import('../../../containers/Channels/Channels'));
const Posts = lazy(() => import('../../../containers/Posts/Posts'));
const Salepoints = lazy(() => import('../../../containers/Salepoints/Salepoints'));
const Resources = lazy(() => import('../../../containers/Resources/Resources'));
const Sectors = lazy(() => import('../../../containers/Sectors/Sectors'));
const Cashregisters = lazy(() => import('../../../containers/Cashregisters/Cashregisters'));
const Messages = lazy(() => import('../../../containers/Messages/Messages'));
const Plan = lazy(() => import('../../../containers/Plan/Plan'));
const Sections = lazy(() => import('../../../containers/Sections/Sections'));
const Customers = lazy(() => import('../../../containers/Customers/Customers'));
const Settings = lazy(() => import('../../../containers/Settings/Settings'));
const Placeholder = lazy(() => import('../../../containers/Placeholder/Placeholder'));
const Dashboard = lazy(() => import('../../../containers/Dashboard/Dashboard'));
const Dashboards = lazy(() => import('../../../containers/Dashboards/Dashboards'));
const TicketackUsers = lazy(() => import('../../../containers/TicketackUsers/TicketackUsers'));
const Phases = lazy(() => import('../../../containers/Phases/Phases'));
const Periods = lazy(() => import('../../../containers/Periods/Periods'));
const Applications = lazy(() => import('../../../containers/Applications/Applications'));
const ApplicationTypes = lazy(() => import('../../../containers/ApplicationTypes/ApplicationTypes'));
const CronTasks = lazy(() => import('../../../containers/CronTasks/CronTasks'));
const StatsAccounting = lazy(() => import('../../Stats/StatsAccounting/StatsAccounting'));
const StatsAttendance = lazy(() => import('../../Stats/StatsAttendance/StatsAttendance'));
const Stats = lazy(() => import('../../../containers/Stats/Stats'));
const PostHogAnalytics = lazy(() => import('../../Stats/PostHogAnalytics/PostHogAnalytics'));
const PlausibleAnalytics = lazy(() => import('../../Stats/PlausibleAnalytics/PlausibleAnalytics'));
const Devices = lazy(() => import('../../../containers/Devices/Devices'));
const Editions = lazy(() => import('../../../containers/Editions/Editions'));
const EquipmentCatalog = lazy(() => import('../../../containers/EquipmentCatalog/EquipmentCatalog'));
const EquipmentPlanning = lazy(() => import('../../../containers/EquipmentPlanning/EquipmentPlanning'));
const EquipmentOrders = lazy(() => import('../../../containers/EquipmentOrders/EquipmentOrders'));
const Workflows = lazy(() => import('../../../containers/Workflows/Workflows'));
const WorkflowsRuns = lazy(() => import('../../../containers/Workflows/WorkflowsRuns/WorkflowsRuns'));
const WorkflowRunDetail = lazy(() => import('../../../containers/Workflows/WorkflowsRuns/WorkflowRunDetail'));
const WorkflowRunDelete = lazy(() => import('../../../containers/Workflows/WorkflowsRuns/WorkflowRunDelete'));
const EngineLogs = lazy(() => import('../../../containers/EngineLogs/EngineLogs'));
const EmailCampaigns = lazy(() => import('../../../containers/EngineLogs/EmailCampaigns'));

export const LAZY_ROUTES = [
    { exact: true, path: '/', component: Dashboard },
    { path: '/admin', component: Dashboards },
    { path: '/analysis', component: Dashboards },
    { exact: true, path: '/operation', component: Dashboard },
    { path: '/users', component: Users },
    { path: '/screenings', component: Screenings },
    { path: '/tickets', component: Tickets },
    { path: '/reservations', component: Stats },
    { path: '/programmation_groups', component: ProgrammationGroups },
    { path: '/places', component: Places },
    { path: '/tickettypes', component: Tickettypes },
    { path: '/layouts', component: Layouts },
    { path: '/email_layouts', component: EmailLayouts },
    { path: '/form_layouts', component: FormLayouts },
    { path: '/pricinglists', component: Pricinglists },
    { path: '/bucketlists', component: Bucketlists },
    { path: '/tktInstances', component: TktInstances },
    { path: '/distributors', component: Distributors },
    { path: '/events', component: Events },
    { path: '/articles', component: Articles },
    { path: '/articlecategories', component: Articlecategories },
    { path: '/post_categories', component: Postcategories },
    { path: '/channels', component: Channels },
    { path: '/posts', component: Posts },
    { path: '/salepoints', component: Salepoints },
    { path: '/activities', component: Activities },
    { path: '/tasks', component: Tasks },
    { path: '/resources', component: Resources },
    { path: '/cashregisters', component: Cashregisters },
    { path: '/messages', component: Messages },
    { path: '/sections', component: Sections },
    { path: '/customers', component: Customers },
    { path: '/settings', component: Settings },
    { path: '/cron_tasks', component: CronTasks },
    { path: '/saleslist', component: Placeholder },
    { path: '/bookingstatus', component: Stats },
    { path: '/bookingsurvey', component: Placeholder },
    { path: '/stats/accounting', component: StatsAccounting },
    { path: '/stats/attendance', component: StatsAttendance },
    { path: '/ticketack_users', component: TicketackUsers },
    { path: '/phases', component: Phases },
    { path: '/periods', component: Periods },
    { path: '/sectors', component: Sectors },
    { path: '/applications', component: Applications },
    { path: '/application_types', component: ApplicationTypes },
    { path: '/personnal_fields', component: Placeholder },
    { exact: true, path: '/configuration_qr_codes/:mode', component: ConfigurationQrCodes },
    { exact: true, path: '/configuration_qr_codes', component: ConfigurationQrCodes },
    { path: '/plan', component: Plan },
    { path: '/stats/movies', component: Stats },
    { path: '/stats/prices', component: Stats },
    { path: '/stats/places', component: Stats },
    { path: '/stats/days', component: Stats },
    { path: '/stats/hours', component: Stats },
    { path: '/stats/box_office', component: Stats },
    { path: '/stats/bookings', component: Stats },
    { path: '/analysis/bookings', component: Stats },
    { path: '/analysis/votes', component: Stats },
    { path: '/devices', component: Devices },
    { path: '/editions', component: Editions },
    { path: '/equipment_catalog/edit/:articleId', component: EquipmentCatalog },
    { path: '/equipment_catalog/new', component: EquipmentCatalog },
    { path: '/equipment_catalog', component: EquipmentCatalog },
    { path: '/equipment_planning', component: EquipmentPlanning },
    { path: '/equipment_orders', component: EquipmentOrders },
    { path: '/workflows', component: Workflows },
    { exact: true, path: '/operation/workflows/:workflowId/runs', component: WorkflowsRuns },
    { exact: true, path: '/operation/workflows/:workflowId/runs/view/:runId', component: WorkflowRunDetail },
    { exact: true, path: '/operation/workflows/:workflowId/runs/delete/:runId', component: WorkflowRunDelete },
    { exact: true, path: '/analysis/system/logs', component: EngineLogs },
    { exact: true, path: '/analysis/email_campaigns', component: EmailCampaigns },
    { exact: true, path: '/analysis/posthog', component: PostHogAnalytics },
    { exact: true, path: '/analysis/web_traffic', component: PlausibleAnalytics },
];
